import CustomActionAlerts from "@/components/Alert/CustomActionAlerts";
import CustomLoadingButton from "@/components/Button/CustomLoadingButton";
import FormCard from "@/components/Card/FomCard";
import PaddedCardContainer from "@/components/Card/PaddedCardContainer";
import SpacingGrid from "@/components/Grid/SpacingGrid";
import CustomOverlapLoader from "@/components/Loader/CustomOverLapLoader";
import { useDialogDispatch } from "@/context/DialogContext";
import { useSnackbarDispatch } from "@/context/SnackbarContext";
import { messages } from "@/messages";
import { Box } from "@mui/material";
import { useUploadBulkListItem } from "../beeswaxList.hook";
import {
  IFormProps,
  ListItemModuleByTypeKey,
  ListItemsApiResponse,
} from "../beeswaxList.interface";
import { listItemModuleByType, listTypeList } from "../data";
import ListItemsTable from "./ListItemsTable";
export default function ListType({
  id,
  errors,
  control,
  getValues,
  setValue,
  isEdit = false,
  listItem,
  listItems,
  listItemsLoading,
  refetchListItems,
  isActive,
  dirtyFields,
}: ListTypeProps) {
  const ListModule =
    listItemModuleByType[listItem.componentKey as ListItemModuleByTypeKey];

  const { setSnackbarState } = useSnackbarDispatch();

  const { mutate: createBulkListItem, isLoading: creatingBulkListItem } =
    useUploadBulkListItem();
  const { closeDialog } = useDialogDispatch();
  async function onUploadListItem(file: any, id: number) {
    try {
      const result = await createBulkListItem(file, id);
      if (result && result?.success) {
        setSnackbarState({
          open: true,
          message: messages.createdSuccessfully("List Item"),
        });
        refetchListItems();
      }
    } catch (error: any) {
      setSnackbarState({
        open: true,
        message: error?.errMsg || error,
        severity: "error",
      });
    }
  }

  return (
    <FormCard label={listItem?.label ?? ""}>
      <SpacingGrid spacingType="layout">
        <SpacingGrid itemContainer>
          <PaddedCardContainer shadow={false} secondaryColor>
            <CustomOverlapLoader isLoading={listItemsLoading}>
              <>
                <ListModule
                  id={parseInt(id)}
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                  isEdit={isEdit}
                  onUploadListItem={onUploadListItem}
                  isUploadingListItem={creatingBulkListItem}
                  subText={
                    "Upload csv, txt. One item per line. Any existing List Items included in the upload will be updated."
                  }
                  isActive={isActive}
                  inActiveText={"Activate the List to upload List Items"}
                />
                <CustomActionAlerts
                  alert={!listItemsLoading && !listItems?.payload.length}
                  severity="warning"
                  message={<Box>{messages.noBeeswaxListItems}</Box>}
                />
                {!listItemsLoading && listItems?.payload.length ? (
                  <ListItemsTable data={listItems.payload} />
                ) : (
                  <></>
                )}
              </>
            </CustomOverlapLoader>
          </PaddedCardContainer>
        </SpacingGrid>
        <SpacingGrid item justifyContent="flex-end">
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <CustomLoadingButton
              title="Close"
              disabled={creatingBulkListItem}
              isLoading={false}
              name="close"
              onClick={closeDialog}
            />
          </Box>
        </SpacingGrid>
      </SpacingGrid>
    </FormCard>
  );
}

interface ListTypeProps extends IFormProps {
  type: ListItemModuleByTypeKey;
  id: string;
  listItem: (typeof listTypeList)[number];
  listItems: ListItemsApiResponse;
  listItemsLoading: boolean;
  refetchListItems: () => void;
  isActive: boolean;
}
